<template>
    <div class="result">
        <Header ref="header" :title="title" @backPage="onBackPage"></Header>
        <div class="container">
            <div class="img"><img src="../../../assets/img/b2b/img_right@2x.png" alt=""></div>
            <div class="title">提交成功</div>
            <div class="p">稍后会有专业人员与您确认询价信息，请保持电话畅通</div>
            <div class="btn">
                <van-button round color="#FF7A45" @click="handleDetail" plain>查看询价记录</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
export default {
    name: 'addResult',
    components: {
        Header
    },
    data () {
        return {
            title: '提交成功'
        }
    },
    methods: {
        onBackPage () {
            this.$router.push({ path: '/b2b/home/index' })
        },
        handleDetail () {
            this.$router.push({ path: '/b2b/inquiry/inquiryList' })
        }
    }
}
</script>

<style lang="scss" scoped>
    .result {
        background: #ffffff;
        height: 100%;
    }
    .container {
        padding-top: 120px;
        text-align: center;
        .img{
            width: 144px;
            height: 144px;
            margin: 0 auto;
        }
        .title{
            font-size: 36px;
            color: #000000;
            margin: 48px 0 16px;
        }
        .p {
            color: #8E8E93;
            font-size: 28px;
        }
        .btn{
            margin-top: 102px;
        }
    }
    /deep/ .van-button--normal {
        font-size: 36px;
        width: 494px;
        padding: 26px 0;
        height: initial;
    }
</style>